/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Cart,
  CartList,
  CartModificationList,
  DeliveryInfo,
  ErrorList,
  PaymentModeList,
  SAPAccessCode,
  SAPFiscalIdRequest,
  SAPGuestUserRequest,
} from '../models';
import {
    CartFromJSON,
    CartToJSON,
    CartListFromJSON,
    CartListToJSON,
    CartModificationListFromJSON,
    CartModificationListToJSON,
    DeliveryInfoFromJSON,
    DeliveryInfoToJSON,
    ErrorListFromJSON,
    ErrorListToJSON,
    PaymentModeListFromJSON,
    PaymentModeListToJSON,
    SAPAccessCodeFromJSON,
    SAPAccessCodeToJSON,
    SAPFiscalIdRequestFromJSON,
    SAPFiscalIdRequestToJSON,
    SAPGuestUserRequestFromJSON,
    SAPGuestUserRequestToJSON,
} from '../models';

export interface AddAEntryCodeToACartRequest {
    baseSiteId: string;
    cartId: string;
    userId: string;
    entryCode?: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface CreateCartRequest {
    baseSiteId: string;
    userId: string;
    fields?: string;
    oldCartId?: string;
    toMergeCartGuid?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface CreateCartGuestUserRequest {
    baseSiteId: string;
    cartId: string;
    userId: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
    sAPGuestUserRequest?: SAPGuestUserRequest;
}

export interface GetCartRequest {
    baseSiteId: string;
    cartId: string;
    userId: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface GetCartIdAccessCodeRequest {
    baseSiteId: string;
    cartId: string;
    userId: string;
    sapCommerceCloudCustomerId?: string;
}

export interface GetCartsRequest {
    baseSiteId: string;
    userId: string;
    currentPage?: number;
    fields?: string;
    pageSize?: number;
    savedCartsOnly?: boolean;
    sort?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface GetPaymentModesRequest {
    baseSiteId: string;
    cartId: string;
    userId: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface RemoveCartRequest {
    baseSiteId: string;
    cartId: string;
    userId: string;
    sapCommerceCloudCustomerId?: string;
}

export interface ReplaceCartDeliveryInfoRequest {
    baseSiteId: string;
    cartId: string;
    userId: string;
    deliveryInfo: DeliveryInfo;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface ReplaceCartGuestUserRequest {
    baseSiteId: string;
    cartId: string;
    email: string;
    userId: string;
    sapCommerceCloudCustomerId?: string;
}

export interface SetCartRequestedRetrievalDateRequest {
    baseSiteId: string;
    cartId: string;
    userId: string;
    requestedRetrievalAt?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface SetFiscalIdsRequest {
    baseSiteId: string;
    cartId: string;
    userId: string;
    sAPFiscalIdRequest: SAPFiscalIdRequest;
    sapCommerceCloudCustomerId?: string;
}

export interface SetGuestUserEmailRequest {
    baseSiteId: string;
    cartId: string;
    userId: string;
    sAPGuestUserRequest: SAPGuestUserRequest;
    sapCommerceCloudCustomerId?: string;
}

export interface SetPaymentModeRequest {
    baseSiteId: string;
    cartId: string;
    paymentModeCode: string;
    userId: string;
    sapCommerceCloudCustomerId?: string;
}

export interface UpdateCurrentUserProfileRequest {
    baseSiteId: string;
    cartId: string;
    userId: string;
    sAPGuestUserRequest: SAPGuestUserRequest;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface ValidateCartRequest {
    baseSiteId: string;
    cartId: string;
    userId: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

/**
 * CartsApi - interface
 * 
 * @export
 * @interface CartsApiInterface
 */
export interface CartsApiInterface {
    /**
     * Authorizes the cart and add the entry code. The response is created 201
     * @summary Add a entry code to a cart
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {string} [entryCode] Entry Code to the order
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApiInterface
     */
    addAEntryCodeToACartRaw(requestParameters: AddAEntryCodeToACartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Authorizes the cart and add the entry code. The response is created 201
     * Add a entry code to a cart
     */
    addAEntryCodeToACart(requestParameters: AddAEntryCodeToACartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates a new cart or restores an anonymous cart as a user\'s cart (if an old Cart Id is given in the request).
     * @summary Creates or restore a cart for a user.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [oldCartId] Anonymous cart GUID.
     * @param {string} [toMergeCartGuid] The cart GUID that will be merged with the anonymous cart.
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApiInterface
     */
    createCartRaw(requestParameters: CreateCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Cart>>;

    /**
     * Creates a new cart or restores an anonymous cart as a user\'s cart (if an old Cart Id is given in the request).
     * Creates or restore a cart for a user.
     */
    createCart(requestParameters: CreateCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Cart>;

    /**
     * Creates a guest user, and assigns the user to the cart. This API is specifically designed to create a guest user for a cart that only has an anonymous user assigned.  Note: API will deny access if the cart already has a normal user or a guest user assigned. 
     * @summary Creates a guest user for the cart.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {SAPGuestUserRequest} [sAPGuestUserRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApiInterface
     */
    createCartGuestUserRaw(requestParameters: CreateCartGuestUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SAPGuestUserRequest>>;

    /**
     * Creates a guest user, and assigns the user to the cart. This API is specifically designed to create a guest user for a cart that only has an anonymous user assigned.  Note: API will deny access if the cart already has a normal user or a guest user assigned. 
     * Creates a guest user for the cart.
     */
    createCartGuestUser(requestParameters: CreateCartGuestUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SAPGuestUserRequest>;

    /**
     * Retrieves a cart using the cart identifier. To get entryGroup information, set fields value as follows: fields=entryGroups(BASIC), fields=entryGroups(DEFAULT), or fields=entryGroups(FULL).
     * @summary Retrieves a cart.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApiInterface
     */
    getCartRaw(requestParameters: GetCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Cart>>;

    /**
     * Retrieves a cart using the cart identifier. To get entryGroup information, set fields value as follows: fields=entryGroups(BASIC), fields=entryGroups(DEFAULT), or fields=entryGroups(FULL).
     * Retrieves a cart.
     */
    getCart(requestParameters: GetCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Cart>;

    /**
     * Generates an access code for the specified cart. An access code is composed by a payload part and a signature part.
     * @summary Generates an access code for the cart.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApiInterface
     */
    getCartIdAccessCodeRaw(requestParameters: GetCartIdAccessCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SAPAccessCode>>;

    /**
     * Generates an access code for the specified cart. An access code is composed by a payload part and a signature part.
     * Generates an access code for the cart.
     */
    getCartIdAccessCode(requestParameters: GetCartIdAccessCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SAPAccessCode>;

    /**
     * Retrieves a list of all the carts associated with a customer.
     * @summary Retrieves the carts of a customer.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {number} [currentPage] Pagination for savedCartsOnly. Default value is 0.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {number} [pageSize] Number of results returned per page if the savedCartsOnly parameter is set to true. Default value: 20.
     * @param {boolean} [savedCartsOnly] If the value is true, only saved carts are returned.
     * @param {string} [sort] Sorting method applied to the return results if the savedCartsOnly parameter is set to true.
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApiInterface
     */
    getCartsRaw(requestParameters: GetCartsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CartList>>;

    /**
     * Retrieves a list of all the carts associated with a customer.
     * Retrieves the carts of a customer.
     */
    getCarts(requestParameters: GetCartsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CartList>;

    /**
     * Retrieves the payment modes defined for the base store and available for cart.
     * @summary Retrieves the available payment modes for cart.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApiInterface
     */
    getPaymentModesRaw(requestParameters: GetPaymentModesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentModeList>>;

    /**
     * Retrieves the payment modes defined for the base store and available for cart.
     * Retrieves the available payment modes for cart.
     */
    getPaymentModes(requestParameters: GetPaymentModesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentModeList>;

    /**
     * Deletes the cart based on the provided cart identifier.
     * @summary Deletes the cart.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApiInterface
     */
    removeCartRaw(requestParameters: RemoveCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Deletes the cart based on the provided cart identifier.
     * Deletes the cart.
     */
    removeCart(requestParameters: RemoveCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Updates the delivery info details for the cart.
     * @summary Updates the delivery info for the cart.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {DeliveryInfo} deliveryInfo 
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApiInterface
     */
    replaceCartDeliveryInfoRaw(requestParameters: ReplaceCartDeliveryInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryInfo>>;

    /**
     * Updates the delivery info details for the cart.
     * Updates the delivery info for the cart.
     */
    replaceCartDeliveryInfo(requestParameters: ReplaceCartDeliveryInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryInfo>;

    /**
     * Assigns an email to the cart. This endpoint is deprecated in the 2211.28 update and its deletion is planned. Please use \'/setEmail\' instead.
     * @summary Assigns an email address to the cart.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} email Email of the guest user. It will be used during the checkout process.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CartsApiInterface
     */
    replaceCartGuestUserRaw(requestParameters: ReplaceCartGuestUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Assigns an email to the cart. This endpoint is deprecated in the 2211.28 update and its deletion is planned. Please use \'/setEmail\' instead.
     * Assigns an email address to the cart.
     */
    replaceCartGuestUser(requestParameters: ReplaceCartGuestUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Sets the requested retrieval date with a given date for the cart.
     * @summary Sets the requested retrieval date for a cart.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {string} [requestedRetrievalAt] Customer requested date for order retrieval
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApiInterface
     */
    setCartRequestedRetrievalDateRaw(requestParameters: SetCartRequestedRetrievalDateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Sets the requested retrieval date with a given date for the cart.
     * Sets the requested retrieval date for a cart.
     */
    setCartRequestedRetrievalDate(requestParameters: SetCartRequestedRetrievalDateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Validates and persists fiscal ID entries for the specified cart.
     * @summary Sets fiscal ID entries on a cart.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {SAPFiscalIdRequest} sAPFiscalIdRequest 
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApiInterface
     */
    setFiscalIdsRaw(requestParameters: SetFiscalIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validates and persists fiscal ID entries for the specified cart.
     * Sets fiscal ID entries on a cart.
     */
    setFiscalIds(requestParameters: SetFiscalIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Assigns an email to the cart. This endpoint is added in the 2211.28 update.
     * @summary Assigns an email address to the cart.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {SAPGuestUserRequest} sAPGuestUserRequest 
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApiInterface
     */
    setGuestUserEmailRaw(requestParameters: SetGuestUserEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Assigns an email to the cart. This endpoint is added in the 2211.28 update.
     * Assigns an email address to the cart.
     */
    setGuestUserEmail(requestParameters: SetGuestUserEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Set payment mode on cart
     * @summary Set payment mode on cart
     * @param {string} baseSiteId Base site identifier
     * @param {string} cartId Cart identifier
     * @param {string} paymentModeCode 
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApiInterface
     */
    setPaymentModeRaw(requestParameters: SetPaymentModeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Set payment mode on cart
     * Set payment mode on cart
     */
    setPaymentMode(requestParameters: SetPaymentModeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Updates profile for current cart guest user. This API is specifically designed to update profile for guest user, so it can only be accessed after a guest user has been created for the cart. Only attributes provided in the request body will be changed.  Note: API will deny access if the cart already has a normal user or no user assigned 
     * @summary Updates profile for current cart guest user.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {SAPGuestUserRequest} sAPGuestUserRequest 
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApiInterface
     */
    updateCurrentUserProfileRaw(requestParameters: UpdateCurrentUserProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SAPGuestUserRequest>>;

    /**
     * Updates profile for current cart guest user. This API is specifically designed to update profile for guest user, so it can only be accessed after a guest user has been created for the cart. Only attributes provided in the request body will be changed.  Note: API will deny access if the cart already has a normal user or no user assigned 
     * Updates profile for current cart guest user.
     */
    updateCurrentUserProfile(requestParameters: UpdateCurrentUserProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SAPGuestUserRequest>;

    /**
     * Validates the cart and returns the cart data during checkout and quotation.
     * @summary Validates the cart.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartsApiInterface
     */
    validateCartRaw(requestParameters: ValidateCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CartModificationList>>;

    /**
     * Validates the cart and returns the cart data during checkout and quotation.
     * Validates the cart.
     */
    validateCart(requestParameters: ValidateCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CartModificationList>;

}

/**
 * 
 */
export class CartsApi extends runtime.BaseAPI implements CartsApiInterface {

    /**
     * Authorizes the cart and add the entry code. The response is created 201
     * Add a entry code to a cart
     */
    async addAEntryCodeToACartRaw(requestParameters: AddAEntryCodeToACartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling addAEntryCodeToACart.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling addAEntryCodeToACart.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling addAEntryCodeToACart.');
        }

        const queryParameters: any = {};

        if (requestParameters.entryCode !== undefined) {
            queryParameters['entryCode'] = requestParameters.entryCode;
        }

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/entryCode`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Authorizes the cart and add the entry code. The response is created 201
     * Add a entry code to a cart
     */
    async addAEntryCodeToACart(requestParameters: AddAEntryCodeToACartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addAEntryCodeToACartRaw(requestParameters, initOverrides);
    }

    /**
     * Creates a new cart or restores an anonymous cart as a user\'s cart (if an old Cart Id is given in the request).
     * Creates or restore a cart for a user.
     */
    async createCartRaw(requestParameters: CreateCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Cart>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling createCart.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling createCart.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        if (requestParameters.oldCartId !== undefined) {
            queryParameters['oldCartId'] = requestParameters.oldCartId;
        }

        if (requestParameters.toMergeCartGuid !== undefined) {
            queryParameters['toMergeCartGuid'] = requestParameters.toMergeCartGuid;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CartFromJSON(jsonValue));
    }

    /**
     * Creates a new cart or restores an anonymous cart as a user\'s cart (if an old Cart Id is given in the request).
     * Creates or restore a cart for a user.
     */
    async createCart(requestParameters: CreateCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Cart> {
        const response = await this.createCartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a guest user, and assigns the user to the cart. This API is specifically designed to create a guest user for a cart that only has an anonymous user assigned.  Note: API will deny access if the cart already has a normal user or a guest user assigned. 
     * Creates a guest user for the cart.
     */
    async createCartGuestUserRaw(requestParameters: CreateCartGuestUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SAPGuestUserRequest>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling createCartGuestUser.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling createCartGuestUser.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling createCartGuestUser.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/guestuser`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SAPGuestUserRequestToJSON(requestParameters.sAPGuestUserRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SAPGuestUserRequestFromJSON(jsonValue));
    }

    /**
     * Creates a guest user, and assigns the user to the cart. This API is specifically designed to create a guest user for a cart that only has an anonymous user assigned.  Note: API will deny access if the cart already has a normal user or a guest user assigned. 
     * Creates a guest user for the cart.
     */
    async createCartGuestUser(requestParameters: CreateCartGuestUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SAPGuestUserRequest> {
        const response = await this.createCartGuestUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a cart using the cart identifier. To get entryGroup information, set fields value as follows: fields=entryGroups(BASIC), fields=entryGroups(DEFAULT), or fields=entryGroups(FULL).
     * Retrieves a cart.
     */
    async getCartRaw(requestParameters: GetCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Cart>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getCart.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling getCart.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getCart.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CartFromJSON(jsonValue));
    }

    /**
     * Retrieves a cart using the cart identifier. To get entryGroup information, set fields value as follows: fields=entryGroups(BASIC), fields=entryGroups(DEFAULT), or fields=entryGroups(FULL).
     * Retrieves a cart.
     */
    async getCart(requestParameters: GetCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Cart> {
        const response = await this.getCartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generates an access code for the specified cart. An access code is composed by a payload part and a signature part.
     * Generates an access code for the cart.
     */
    async getCartIdAccessCodeRaw(requestParameters: GetCartIdAccessCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SAPAccessCode>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getCartIdAccessCode.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling getCartIdAccessCode.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getCartIdAccessCode.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/accessCode`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SAPAccessCodeFromJSON(jsonValue));
    }

    /**
     * Generates an access code for the specified cart. An access code is composed by a payload part and a signature part.
     * Generates an access code for the cart.
     */
    async getCartIdAccessCode(requestParameters: GetCartIdAccessCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SAPAccessCode> {
        const response = await this.getCartIdAccessCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a list of all the carts associated with a customer.
     * Retrieves the carts of a customer.
     */
    async getCartsRaw(requestParameters: GetCartsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CartList>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getCarts.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getCarts.');
        }

        const queryParameters: any = {};

        if (requestParameters.currentPage !== undefined) {
            queryParameters['currentPage'] = requestParameters.currentPage;
        }

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.savedCartsOnly !== undefined) {
            queryParameters['savedCartsOnly'] = requestParameters.savedCartsOnly;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CartListFromJSON(jsonValue));
    }

    /**
     * Retrieves a list of all the carts associated with a customer.
     * Retrieves the carts of a customer.
     */
    async getCarts(requestParameters: GetCartsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CartList> {
        const response = await this.getCartsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the payment modes defined for the base store and available for cart.
     * Retrieves the available payment modes for cart.
     */
    async getPaymentModesRaw(requestParameters: GetPaymentModesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentModeList>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getPaymentModes.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling getPaymentModes.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getPaymentModes.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/paymentmodes`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentModeListFromJSON(jsonValue));
    }

    /**
     * Retrieves the payment modes defined for the base store and available for cart.
     * Retrieves the available payment modes for cart.
     */
    async getPaymentModes(requestParameters: GetPaymentModesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentModeList> {
        const response = await this.getPaymentModesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes the cart based on the provided cart identifier.
     * Deletes the cart.
     */
    async removeCartRaw(requestParameters: RemoveCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling removeCart.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling removeCart.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling removeCart.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes the cart based on the provided cart identifier.
     * Deletes the cart.
     */
    async removeCart(requestParameters: RemoveCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeCartRaw(requestParameters, initOverrides);
    }

    /**
     * Updates the delivery info details for the cart.
     * Updates the delivery info for the cart.
     */
    async replaceCartDeliveryInfoRaw(requestParameters: ReplaceCartDeliveryInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryInfo>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling replaceCartDeliveryInfo.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling replaceCartDeliveryInfo.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling replaceCartDeliveryInfo.');
        }

        if (requestParameters.deliveryInfo === null || requestParameters.deliveryInfo === undefined) {
            throw new runtime.RequiredError('deliveryInfo','Required parameter requestParameters.deliveryInfo was null or undefined when calling replaceCartDeliveryInfo.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/xml';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/deliveryinfo`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryInfoToJSON(requestParameters.deliveryInfo),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryInfoFromJSON(jsonValue));
    }

    /**
     * Updates the delivery info details for the cart.
     * Updates the delivery info for the cart.
     */
    async replaceCartDeliveryInfo(requestParameters: ReplaceCartDeliveryInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryInfo> {
        const response = await this.replaceCartDeliveryInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Assigns an email to the cart. This endpoint is deprecated in the 2211.28 update and its deletion is planned. Please use \'/setEmail\' instead.
     * Assigns an email address to the cart.
     */
    async replaceCartGuestUserRaw(requestParameters: ReplaceCartGuestUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling replaceCartGuestUser.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling replaceCartGuestUser.');
        }

        if (requestParameters.email === null || requestParameters.email === undefined) {
            throw new runtime.RequiredError('email','Required parameter requestParameters.email was null or undefined when calling replaceCartGuestUser.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling replaceCartGuestUser.');
        }

        const queryParameters: any = {};

        if (requestParameters.email !== undefined) {
            queryParameters['email'] = requestParameters.email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/email`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Assigns an email to the cart. This endpoint is deprecated in the 2211.28 update and its deletion is planned. Please use \'/setEmail\' instead.
     * Assigns an email address to the cart.
     */
    async replaceCartGuestUser(requestParameters: ReplaceCartGuestUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.replaceCartGuestUserRaw(requestParameters, initOverrides);
    }

    /**
     * Sets the requested retrieval date with a given date for the cart.
     * Sets the requested retrieval date for a cart.
     */
    async setCartRequestedRetrievalDateRaw(requestParameters: SetCartRequestedRetrievalDateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling setCartRequestedRetrievalDate.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling setCartRequestedRetrievalDate.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling setCartRequestedRetrievalDate.');
        }

        const queryParameters: any = {};

        if (requestParameters.requestedRetrievalAt !== undefined) {
            queryParameters['requestedRetrievalAt'] = requestParameters.requestedRetrievalAt;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/requestedretrievaldate`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Sets the requested retrieval date with a given date for the cart.
     * Sets the requested retrieval date for a cart.
     */
    async setCartRequestedRetrievalDate(requestParameters: SetCartRequestedRetrievalDateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setCartRequestedRetrievalDateRaw(requestParameters, initOverrides);
    }

    /**
     * Validates and persists fiscal ID entries for the specified cart.
     * Sets fiscal ID entries on a cart.
     */
    async setFiscalIdsRaw(requestParameters: SetFiscalIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling setFiscalIds.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling setFiscalIds.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling setFiscalIds.');
        }

        if (requestParameters.sAPFiscalIdRequest === null || requestParameters.sAPFiscalIdRequest === undefined) {
            throw new runtime.RequiredError('sAPFiscalIdRequest','Required parameter requestParameters.sAPFiscalIdRequest was null or undefined when calling setFiscalIds.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/fiscalIds`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SAPFiscalIdRequestToJSON(requestParameters.sAPFiscalIdRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validates and persists fiscal ID entries for the specified cart.
     * Sets fiscal ID entries on a cart.
     */
    async setFiscalIds(requestParameters: SetFiscalIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setFiscalIdsRaw(requestParameters, initOverrides);
    }

    /**
     * Assigns an email to the cart. This endpoint is added in the 2211.28 update.
     * Assigns an email address to the cart.
     */
    async setGuestUserEmailRaw(requestParameters: SetGuestUserEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling setGuestUserEmail.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling setGuestUserEmail.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling setGuestUserEmail.');
        }

        if (requestParameters.sAPGuestUserRequest === null || requestParameters.sAPGuestUserRequest === undefined) {
            throw new runtime.RequiredError('sAPGuestUserRequest','Required parameter requestParameters.sAPGuestUserRequest was null or undefined when calling setGuestUserEmail.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/setEmail`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SAPGuestUserRequestToJSON(requestParameters.sAPGuestUserRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Assigns an email to the cart. This endpoint is added in the 2211.28 update.
     * Assigns an email address to the cart.
     */
    async setGuestUserEmail(requestParameters: SetGuestUserEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setGuestUserEmailRaw(requestParameters, initOverrides);
    }

    /**
     * Set payment mode on cart
     * Set payment mode on cart
     */
    async setPaymentModeRaw(requestParameters: SetPaymentModeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling setPaymentMode.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling setPaymentMode.');
        }

        if (requestParameters.paymentModeCode === null || requestParameters.paymentModeCode === undefined) {
            throw new runtime.RequiredError('paymentModeCode','Required parameter requestParameters.paymentModeCode was null or undefined when calling setPaymentMode.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling setPaymentMode.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/payment-mode/{paymentModeCode}`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"paymentModeCode"}}`, encodeURIComponent(String(requestParameters.paymentModeCode))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Set payment mode on cart
     * Set payment mode on cart
     */
    async setPaymentMode(requestParameters: SetPaymentModeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setPaymentModeRaw(requestParameters, initOverrides);
    }

    /**
     * Updates profile for current cart guest user. This API is specifically designed to update profile for guest user, so it can only be accessed after a guest user has been created for the cart. Only attributes provided in the request body will be changed.  Note: API will deny access if the cart already has a normal user or no user assigned 
     * Updates profile for current cart guest user.
     */
    async updateCurrentUserProfileRaw(requestParameters: UpdateCurrentUserProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SAPGuestUserRequest>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling updateCurrentUserProfile.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling updateCurrentUserProfile.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling updateCurrentUserProfile.');
        }

        if (requestParameters.sAPGuestUserRequest === null || requestParameters.sAPGuestUserRequest === undefined) {
            throw new runtime.RequiredError('sAPGuestUserRequest','Required parameter requestParameters.sAPGuestUserRequest was null or undefined when calling updateCurrentUserProfile.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/guestuser`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SAPGuestUserRequestToJSON(requestParameters.sAPGuestUserRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SAPGuestUserRequestFromJSON(jsonValue));
    }

    /**
     * Updates profile for current cart guest user. This API is specifically designed to update profile for guest user, so it can only be accessed after a guest user has been created for the cart. Only attributes provided in the request body will be changed.  Note: API will deny access if the cart already has a normal user or no user assigned 
     * Updates profile for current cart guest user.
     */
    async updateCurrentUserProfile(requestParameters: UpdateCurrentUserProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SAPGuestUserRequest> {
        const response = await this.updateCurrentUserProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validates the cart and returns the cart data during checkout and quotation.
     * Validates the cart.
     */
    async validateCartRaw(requestParameters: ValidateCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CartModificationList>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling validateCart.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling validateCart.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling validateCart.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/validate`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CartModificationListFromJSON(jsonValue));
    }

    /**
     * Validates the cart and returns the cart data during checkout and quotation.
     * Validates the cart.
     */
    async validateCart(requestParameters: ValidateCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CartModificationList> {
        const response = await this.validateCartRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
